import React from 'react';
import { Reveal } from './Reveal';
import { SlideFrame } from './SlideFrame';
const acts = [{
  act: 'Act I',
  label: 'Before',
  title: 'Set the scene',
  lines: ['Shape the discourse.', 'Set the agenda.', 'Prime the audience.']
}, {
  act: 'Act II',
  label: 'During',
  title: 'Create the conversation',
  lines: ['Start the dialogue.', 'Steer the narrative.', 'Bring the story to life.']
}, {
  act: 'Act III',
  label: 'After',
  title: 'Turn ideas into action',
  lines: ['Close the loop.', 'Convert insight into follow-up.', 'Carry the conversation forward.']
}];
export function CongressJourneySlide() {
  return <SlideFrame data-id="element-98" data-mp="3bu2wikocy6s">
      <header className="relative z-10 pr-[30%]" data-id="element-99" data-mp="3ugkc4wur8u3y">
        <h1 className="font-display text-[clamp(52px,7.2vw,120px)] font-bold leading-[0.94] tracking-[-0.035em]" data-id="element-100" data-mp="3ufsfdipf8qc3">
          A congress is not <span className="text-[#D62B22]" data-id="element-101" data-mp="2j15673kkirwp">3 days.</span>
        </h1>
        <p className="mt-[1.6vh] font-display text-[clamp(24px,2.8vw,48px)] font-medium tracking-[-0.015em] text-black/65" data-id="element-102" data-mp="2izu212n7ni52">
          It’s a play in 3 acts.
        </p>
      </header>

      <img src="https://cdn.magicpatterns.com/uploads/mrPfNmhh1ykVPnGG1Hmdgz/ChatGPT_Image_Sep_1,_2026,_12_00_55_PM.png" alt="Takeda ECCO Copenhagen clapperboard showing the three-act congress journey" width="1296" height="1048" loading="eager" decoding="async" className="absolute right-[-1%] top-[-5%] z-0 w-[clamp(220px,30vw,520px)] h-auto object-contain" data-id="element-103" data-mp="3u6u1pscpea3u" />

      <div className="relative z-10 mt-auto grid grid-cols-3 border-t-[clamp(3px,0.3vw,6px)] border-black" data-id="element-104" data-mp="3bbdmzkyfl6ry">
        {acts.map((act, index) => <Reveal key={act.label} delay={0.08 + index * 0.08} className={`relative min-h-[32vh] pt-[2.4vh] ${index > 0 ? 'border-l border-black/20 pl-[2.4vw]' : ''} ${index < acts.length - 1 ? 'pr-[2.4vw]' : ''}`} data-id="element-105" data-mp="32gfntw4owxs6" data-mpi={index}>
            <div className={`absolute -top-[clamp(5px,0.55vw,10px)] left-0 h-[clamp(5px,0.55vw,10px)] ${index === 1 ? 'w-[42%] bg-[#D62B22]' : 'w-[18%] bg-black'}`} data-id="element-106" data-mp="2skm700jxui4l" />
            <p className="font-sans text-[clamp(12px,0.95vw,18px)] font-semibold tracking-[0.14em]" data-id="element-107" data-mp="24lv9tawsk94r">
              <span className="text-black/35" data-id="element-108" data-mp="1zov1etcgyuah">{act.act} — </span>
              <span className="text-[#D62B22]" data-id="element-109" data-mp="1uq1nx0x6n3ab">{act.label}</span>
            </p>
            <h2 className="mt-[1.8vh] max-w-[12ch] font-display text-[clamp(25px,2.7vw,48px)] font-bold leading-[1.02] tracking-[-0.02em]" data-id="element-110" data-mp="2scqxbvu7si67">
              {act.title}
            </h2>
            <div className="mt-[2.4vh] space-y-[0.65vh]" data-id="element-111" data-mp="2nc391hxdeffo">
              {act.lines.map(line => <p key={line} className="font-sans text-[clamp(14px,1.15vw,21px)] leading-snug text-black/55" data-id="element-112" data-mp="2ignt8kfsy9gm">
                  {line}
                </p>)}
            </div>
          </Reveal>)}
      </div>

      <p className="relative z-10 mt-[1.4vh] text-right font-sans text-[clamp(11px,0.9vw,17px)] text-black/40" data-id="element-113" data-mp="120335hq0tsbg">
        The spotlight does not switch on when ECCO opens — and it should not switch off when ECCO closes.
      </p>
    </SlideFrame>;
}